import React, { useState } from 'react';
import { useIntl } from "react-intl";
const CheckList = ({ msg,unblockNumber }) => {
    const hasBlockedNumbers = msg && Array.isArray(msg) && msg[0].blockedNumbers && msg[0].blockedNumbers.length > 0;
    const intl = useIntl();
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const formatBlockTime = (blockTime) => {
        const now = new Date();
        const blockDate = new Date(blockTime);
        const diffInMs = now - blockDate;
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        if (diffInDays === 0) {
            return "less than a day ago";
        } else if (diffInDays === 1) {
            return "1 day ago";
        } else {
            return `${diffInDays} days ago`;
        }
    };


    
    const handleUnblock = async (type,typeId,number) => {
          const response = await unblockNumber(type,typeId,number);
    
          if (response && response.error) {
              setMessage(response.data.response[0].message);
              setMessageType('error');
          } else if (response && response.data) {
              setMessage(response.data.response[0].message);
               setMessageType(response.data.code==0 ? 'success' : 'error');
          }
    
          setTimeout(() => {
              setMessage('');
              setMessageType('');
          }, 4000);
    };
    


    return (
        <div className="blocked-container">
            <div className="blocked-header">
                <span className="blocked-title">{intl.formatMessage({ id: "CHAT.PAST" })}</span>
                {hasBlockedNumbers && (
                <span className="blocked-view">{intl.formatMessage({ id: "BLUE.DRAW.VIEW_ALL" })}</span>
                )}
            </div>
            {hasBlockedNumbers ? (
                msg[0].blockedNumbers.map((number, index) => (
                    <div key={index} className="blocked-item">
                        <div className="blocked-info">
                            <div className="blocked-number">+{number.msisdn}</div>
                            <div className="blocked-date">{intl.formatMessage({ id: "CHAT.BLOCKED" })} {formatBlockTime(number.blockTime)}</div>
                        </div>
                        <button className="blocked-unblock" onClick={(e) => {
                        e.stopPropagation(); 
                        handleUnblock( msg[0].parentId,2,number.msisdn);
              }}>{intl.formatMessage({ id: "CHAT.UNBLOCK" })}</button>
                    </div>
                ))
            ) : (
                <div className="no-data" style={{
                        color: '#666',
                        fontWeight: 500,
                        margin: '9px 11px 16px'
                    }}>{intl.formatMessage({ id: "NO_DATA_FOUND" })}</div>
            )}

            {message && (
                <div className={`response-message ${messageType}`}>
                    {message}
                </div>
            )}
        </div>
    );
};

export default CheckList;